// extracted by mini-css-extract-plugin
export default {"container":"TaxiFormMsg_container__asVWd","btn":"TaxiFormMsg_btn__OS0zS","text":"TaxiFormMsg_text__6nUho"};